import posthog from 'posthog-js'
import Vue from 'vue'
import type { Plugin } from '@nuxt/types'

const plugin: Plugin = ({ app: { router }, $config }, inject) => {
  if (!$config.POSTHOG_TOKEN) {
    throw new Error('Posthog token is not set in the config')
  }

  posthog.init($config.POSTHOG_TOKEN, {
    api_host: 'https://eu.i.posthog.com',
    capture_pageview: false,
    enable_heatmaps: true,
    enable_recording_console_log: true,
    autocapture: true,
    capture_dead_clicks: true,
    capture_performance: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '*',
    },
  })

  inject('posthog', posthog)

  router?.beforeEach((_to, from, next) => {
    Vue.nextTick(() => {
      posthog.capture('$pageleave', {
        $current_url: new URL(from.fullPath, window.location.origin),
      })
    })
    next()
  })

  router!.afterEach((to) => {
    Vue.nextTick(() => {
      posthog.capture('$pageview', {
        $current_url: new URL(to.fullPath, window.location.origin),
      })
    })
  })

  const originalErrorHandler = Vue.config.errorHandler

  Vue.config.errorHandler = (err, vm, info) => {
    posthog.captureException(err, {
      type: 'vue',
      details: info,
      component: vm.$options.name,
    })
    originalErrorHandler(err, vm, info)
  }
}

export default plugin
